// 暂时注释掉缺少的依赖
// let Base64 = require('js-base64').Base64
const ISDEV = process.env.NODE_ENV === 'development'
/* Vue 3 不再需要 import Vue，原 Vue.prototype 已迁移到 app.config.globalProperties */
// import Vue from 'vue'
import { Message } from '@arco-design/web-vue'
/* 兼容文件中 message.xxx() 的用法（小写） */
const message = Message
import router from "../router"
import store from '../store'
import axios from 'axios'
import env from '../../../env/index'

// -------------- 已替换为 iView --------------
// import iView from 'view-design'
// Vue.use(iView)

// const message = iView.Message
// const Modal = iView.Modal
// const notification = iView.Notice

// Vue.prototype.$message = message
// Vue.prototype.$notification = notification
// Vue.prototype.$info = Modal.info
// Vue.prototype.$success = Modal.success
// Vue.prototype.$error = Modal.error
// Vue.prototype.$warning = Modal.warning
// Vue.prototype.$confirm = Modal.confirm
// Vue.prototype.$destroyAll = Modal.destroyAll

// -------------- 公共组件 --------------
// 暂时注释掉缺少的组件
// import components from '@/components'
// Vue.use(components)

// 暂时注释掉缺少的百度地图
// import BaiduMap from 'vue-baidu-map'
// Vue.use(BaiduMap, { ak: 'R2eTZTK1CIATNfGZSSLu5IdYodrCKrcq' })

/**
 * 接口类
 */
const http = axios.create({
  baseURL: env.API,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json'
  }
})

http.interceptors.request.use((config) => {
  const token = getToken()
  const tokenObj = Object.assign(
    env.TOKEN || {},
    { token: token || '' }
  )
  config.headers['Token'] = JSON.stringify(tokenObj)
  // console.log('请求头Token:', config.headers['Token'])
  return config
}, (error) => {
  return Promise.reject(error)
})

http.interceptors.response.use((response) => {
  return response
}, (error) => {
  if (error.response) {
    const status = error.response.status
    if (status === 401) {
      message.error('登录已失效，请重新登录')
      localStorage.removeItem('token')
      localStorage.removeItem('token-session')
      router.replace({ path: '/login' })
    } else if (status === 404) {
      router.replace({ path: '/error/404' })
    }
  }
  return Promise.reject(error)
})

class ApiClass {
  constructor(params){
  }
  async get(url, req = {}) {
    // console.log('开始执行 Fan.api.get:', url, req)
    store.state.loading = true
    if(process.env.NODE_ENV==='development'){
      console.group('获取数据', url, JSON.stringify(req))
      console.time('耗时')
    }
    return new Promise((resolve, reject) => {
      // console.log('准备发送 GET 请求:', url)
      http.get(url, { params: req }).then(({data}) => {
        // console.log('GET 请求成功:', data)
        console.timeEnd('耗时')
        disposeData(url, resolve, data, false)
        if(process.env.NODE_ENV==='development'){
          console.groupEnd('获取数据', url, JSON.stringify(req))
        }
      }).catch(err => {
        console.error('GET 请求失败:', err)
        console.timeEnd('耗时')
        disposeError(url, reject, err)
        console.groupEnd('获取数据', url, JSON.stringify(req))
      })
    })
  }
  async post(url, req = {}) {
    store.state.loading = true
    if(process.env.NODE_ENV==='development'){
      console.group('新增请求', url, JSON.stringify(req))
      console.time('耗时')
    }
    return new Promise((resolve, reject) => {
      http.post(url, req).then(({data}) => {
        console.timeEnd('耗时')
        disposeData(url, resolve, data)
        if(process.env.NODE_ENV==='development'){
        console.groupEnd('新增请求', url, JSON.stringify(req))
        }
      }).catch(err => {
        console.timeEnd('耗时')
        disposeError(url, reject, err)
        console.groupEnd('新增请求', url, JSON.stringify(req))
      })
    })
  }
  async post2(url, req = {}) {
    store.state.loading = true
    if(process.env.NODE_ENV==='development'){
      console.group('新增请求', url, JSON.stringify(req))
      console.time('耗时')
    }
    return new Promise((resolve, reject) => {
      http.post(url, req).then(({data}) => {
        console.timeEnd('耗时')
        disposeData2(url, resolve, data)
        if(process.env.NODE_ENV==='development'){
        console.groupEnd('新增请求', url, JSON.stringify(req))
        }
      }).catch(err => {
        console.timeEnd('耗时')
        disposeError(url, reject, err)
        console.groupEnd('新增请求', url, JSON.stringify(req))
      })
    })
  }
  async put(url, req = {}) {
    store.state.loading = true
    if(process.env.NODE_ENV==='development'){
    console.group('更新请求', url, JSON.stringify(req))
    console.time('耗时')
    }
    return new Promise((resolve, reject) => {
      http.put(url, req).then(({data}) => {
        if(process.env.NODE_ENV==='development'){
        console.timeEnd('耗时')
        }
        disposeData(url, resolve, data)
        if(process.env.NODE_ENV==='development'){
        console.groupEnd('更新请求', url, JSON.stringify(req))
        }
      }).catch(err => {
        console.timeEnd('耗时')
        disposeError(url, reject, err)
        console.groupEnd('更新请求', url, JSON.stringify(req))
      })
    })
  }
  async delete(url, req = {}) {
    store.state.loading = true
    if(process.env.NODE_ENV==='development'){
      console.group('删除请求', url, JSON.stringify(req))
      console.time('耗时')
    }
    return new Promise((resolve, reject) => {
      http.delete(url, { data: req }).then(({data}) => {
        console.timeEnd('耗时')
        disposeData(url, resolve, data)
        if(process.env.NODE_ENV==='development'){
        console.groupEnd('删除请求', url, JSON.stringify(req))
        }
      }).catch(err => {
        console.timeEnd('耗时')
        disposeError(url, reject, err)
        console.groupEnd('删除请求', url, JSON.stringify(req))
      })
    })
  }
  async upload(url, req = {}) {
    store.state.loading = true
    if(process.env.NODE_ENV==='development'){
    console.group('上传请求', url, JSON.stringify(req))
    console.time('耗时')
    }
    const formData = new FormData()
    formData.append('file', req)
    return new Promise((resolve, reject) => {
      http.post(url, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then(({data}) => {
        console.timeEnd('耗时')
        disposeData(url, resolve, data)
        if(process.env.NODE_ENV==='development'){
        console.groupEnd('上传请求', url, JSON.stringify(req))
        }
      }).catch(err => {
        console.timeEnd('耗时')
        disposeError(url, reject, err)
        console.groupEnd('上传请求', url, JSON.stringify(req))
      })
    })
  }
}

// 状态判断及数据处理
function disposeData(url, resolve, data, success=true) {
  store.state.loading = false
  if(ISDEV) {
    console.log('资源：', url)
    console.log('响应:', '[', 'status:', data.status, '][', 'message:', data.message, ']')
    console.log('数据：', data.data)
  }
  if (data.status === 0) {
    if(data.message == ''){
      data.message ='处理成功'
    }
    if (success) message.success(data.message)
    resolve(data)
  } else if (data.status === 100001100 || data.status === 100001200) {
    message.error('登录已失效，请重新登录')
    localStorage.removeItem('token')
    localStorage.removeItem('token-session')
    setTimeout(() => {
      router.replace({ path: '/login' })
    }, 1000)
  } else {
    message.warning(data.message+` ${data.status}`)
    resolve(data)
  }
}
function disposeData2(url, resolve, data, success=true) {
  store.state.loading = false
  if(ISDEV) {
    console.log('资源：', url)
    console.log('响应:', '[', 'status:', data.status, '][', 'message:', data.message, ']')
    console.log('数据：', data.data)
  }
  if (data.status === 0) {
    if(data.message == ''){
      data.message ='处理成功'
    }
    resolve(data)
  } else if (data.status === 100001100 || data.status === 100001200) {
    message.error('登录已失效，请重新登录')
    localStorage.removeItem('token')
    localStorage.removeItem('token-session')
    setTimeout(() => {
      router.replace({ path: '/login' })
    }, 1000)
  } else {
    message.warning(data.message+` ${data.status}`)
    resolve(data)
  }
}
function disposeError(url, reject, err) {
  store.state.loading = false
  if(ISDEV) {
    console.error(err)
  }
  if (err.response) {
    const status = err.response.status
    if (status === 401) {
      message.error('登录已失效，请重新登录')
      localStorage.removeItem('token')
      localStorage.removeItem('token-session')
      router.replace({ path: '/login' })
    } else if (status === 404) {
      router.replace({ path: '/error/404' })
    } else {
      message.error(err.message || '请求失败')
    }
  } else {
    message.error(err.message || '网络错误')
  }
  reject(err)
}

/**
 * 工具类
 */
class UtilsClass {
  constructor(params){
  }
  parse(val) {
    return JSON.parse(JSON.stringify(val))
  }
  datetime(inputTime) {
    var localTime = ''
    inputTime = new Date(inputTime).getTime()
    const offset = (new Date()).getTimezoneOffset()
    localTime = (new Date(inputTime - offset * 60000)).toISOString()
    localTime = localTime.substr(0, localTime.lastIndexOf('.'))
    localTime = localTime.replace('T', ' ')
    return localTime
  }
  isSet(val) {
    if (
      val ||
      val===false ||
      val===0 ||
      val==="" ||
      val===[] ||
      val==={}
    ) {
      return true
    }
    return false
  }
  notSet(val) {
    return !this.isSet(val)
  }
  isEmpty(val) {
    if (!val || typeof val !== 'object') return true
    if (Object.keys(val).length > 0) {
      return false
    } else {
      return true
    }
  }
  notEmpty(val) {
    if (!val || typeof val !== 'object') return false
    if (Object.keys(val).length > 0) {
      return true
    } else {
      return false
    }
  }
  jsSplit(val){
    let vals = []
    if(val){
      vals = val.split(',')
    }
    return vals
  }
}

/**
 * 本地存储
 */
class StorageClass {
  getStorage(name, key=false) {
    try{
      const storage = JSON.parse(sessionStorage.getItem(name)) || {}
      if (key) {
        if (storage && storage[key]) {
          return storage[key]
        }
        return {}
      }
      return storage || {}
    } catch (e) {
      console.log('getStorage Error', e)
      return {}
    }
  }
  setStorage(name, key, payLoad) {
    try{
      let storage = this.getStorage(name)
      storage[key] = Fan.utils.parse(payLoad)
      sessionStorage.setItem(name, JSON.stringify(storage))
      return {}
    } catch (e) {
      console.log('setStorage Error', e)
      return {}
    }
  }
  removeStorage(name, key=false) {
    try{
      let storage = JSON.parse(sessionStorage.getItem(name)) || {}
      if (storage[key]) {
        delete storage[key]
        sessionStorage.setItem(name, JSON.stringify(storage))
      } else {
        sessionStorage.removeItem(name)
      }
      return true
    } catch (e) {
      console.log('removeStorage Error', e)
      return false
    }
  }
  clearStorage(all=false) {
    try{
      if (all) {
        sessionStorage.clear()
      } else {
        const storage = JSON.parse(sessionStorage.getItem('zee-global_cache')) || {}
        sessionStorage.clear()
        sessionStorage.setItem('zee-global_cache', JSON.stringify(storage))
      }
      return true
    } catch (e) {
      console.log('clearStorage Error', e)
      return false
    }
  }
}

/**
 * 页面操作
 */
class PageClass {
  openClear(url) {
    if(url.indexOf('http://') > -1) {
      const zn = url.indexOf('http://')
      let z1 = url.length - zn
      let uu = url.substr(-z1,z1)
      window.open(uu,"_blank")
    } else if(url.indexOf('https://') > -1) {
      const zn = url.indexOf('https://')
      let z1 = url.length - zn
      let uu = url.substr(-z1,z1)
      window.open(uu,"_blank")
    } else if(url.indexOf(':') > -1) {
      let zn = url.indexOf(':')
      let z1 = url.length - zn-1
      let uu = url.substr(-z1,z1)
      router.push('/'+uu)
    } else {
      router.push({ name: url })
    }
  }
  open(url, query=false) {
    if (query && typeof query === 'object') {
      Fan.storage.setStorage('fan-page_query', url, query)
      console.log('open', url, query)
      // 直接使用 router.push 方法，确保参数显示在地址栏中
      router.push({ path: url, query: query })
    } else if(url.indexOf('http://') > -1) {
      const zn = url.indexOf('http://')
      let z1 = url.length - zn
      let uu = url.substr(-z1,z1)
      window.open(uu,"_blank")
    } else if(url.indexOf('https://') > -1) {
      const zn = url.indexOf('https://')
      let z1 = url.length - zn
      let uu = url.substr(-z1,z1)
      window.open(uu,"_blank")
    } else if(url.indexOf(':') > -1) {
      let zn = url.indexOf(':')
      let z1 = url.length - zn-1
      let uu = url.substr(-z1,z1)
      router.push('/'+uu)
    } else {
      if (url.indexOf('/') === 0) {
        // 如果 url 以 / 开头，使用 path
        router.push({ path: url })
      } else {
        // 否则使用 name
        router.push({ name: url })
      }
    }
  }
  async loadCallback(payloadColumns, payloadData) {
    let tableColumns = []
    let columns = {}
    let keyinfo = {}
    let options = {}
    let i = 0
    for (let k in payloadColumns) {
      const column = payloadColumns[k]
      const field = column.dataIndex || false
      const extendTable = column.extendTable || false
      const extendOption = column.extendOption || false
      const extendOption2 = column.extendOption2 || false
      if (field) {
        columns[field] = {
          name: column.title,
          type: column.dataIndex,
          form: column.form,
          required: column.required,
          search: column.search,
          hidden: column.hidden,
          disabled: column.disabled,
          defaultValue: column.defaultValue,
          placeholder:column.placeholder,
          accept:column.accept,
          linkField: column.linkField,
          labelField: column.labelField,
          linkPlaceholder: column.linkPlaceholder,
          unit: column.unit,
          unitField: column.unitField,
          parentDisabled: column.parentDisabled,
          unitExtendTable: column.unitExtendTable,
          unitExtendOption: column.unitExtendOption
        }
        tableColumns[i] = column
        if (['bool', 'switch'].indexOf(column.form) > -1) {
          tableColumns[i].scopedSlots = { customRender: 'bool' }
        } else if (column.form === 'image') {
          tableColumns[i].scopedSlots = { customRender: 'image' }
        } else if (column.form === 'images') {
          tableColumns[i].scopedSlots = { customRender: 'images' }
        } else if (column.form === 'file') {
          tableColumns[i].scopedSlots = { customRender: 'file' }
        } else if (column.form === 'esign') {
          tableColumns[i].scopedSlots = { customRender: 'esign' }
        } else if (column.form === 'esignbm') {
          tableColumns[i].scopedSlots = { customRender: 'esignbm' }
        } else if (column.form === 'imagebm') {
          tableColumns[i].scopedSlots = { customRender: 'imagebm' }
        } else if (column.form === 'mapPoint') {
          tableColumns[i].scopedSlots = { customRender: 'mapPoint' }
        } else if (column.form === 'mapPloyon') {
          tableColumns[i].scopedSlots = { customRender: 'mapPloyon' }
        } else if (['selectMultiple', 'selectTreeMultiple'].indexOf(column.form) > -1) {
          const _field2 = field
          const _self2 = this
          tableColumns[i].customRender = function({ record }) {
            const val = record[_field2]
            if (!val || (Array.isArray(val) && val.length === 0)) return '-'
            const arr = Array.isArray(val) ? val : String(val).split(',').map(s=>s.trim()).filter(Boolean)
            return arr.map(v => _self2.getOptionName(_field2, v)).filter(Boolean).join(', ') || '-'
          }
        } else if (['radio', 'select', 'cascader', 'selectTree', 'linkSelect'].indexOf(column.form) > -1) {
          const _field = field
          const _self = this
          tableColumns[i].customRender = function({ record }) {
            const val = record[_field]
            if (typeof _self.getOptionName !== 'function') return val
            return _self.getOptionName(_field, val)
          }
        }
        i++
        if (extendTable) {
          const userInfo = store.state.user
          if (extendTable === '_base_area') {
            const global_cache = Fan.storage.getStorage('zee-global_cache')
            const base_area = global_cache.base_area
            let new_base_area = Fan.utils.parse(base_area)
            if (base_area.keyinfo) {
              keyinfo[field] = base_area.keyinfo
            } else {
              keyinfo[field] = getKeyinfo(base_area.data, true)
              new_base_area.keyinfo = options[field]
            }
            if (base_area.options) {
              options[field] = base_area.options
            } else {
              options[field] = getTreeOptions(base_area.data, true)
              new_base_area.options = options[field]
            }
            if (Object.keys(new_base_area).length !== Object.keys(base_area).length) {
              Fan.storage.setStorage('zee-global_cache', 'base_area', new_base_area)
            }
          } else {
            try {
              const res = await Fan.api.get(extendTable, {page: 1, limit: 99999})
              // 兼容双层 {data:{data:[]}} 和单层 []
              let data = (res && res.data) ? res.data : (res || [])
              if (data && data.data && Array.isArray(data.data)) {
                data = data.data
              }
              if (column.form === 'cascader') {
                keyinfo[field] = getKeyinfo(data, true)
                /* 检测API返回的是树形(带children)还是扁平(靠pid关联) */
                const hasTreeData = data && data.length > 0 && data.some(o => o && o.children)
                if (hasTreeData) {
                  options[field] = getTreeOptionsFromNested(data)
                } else if (extendTable=='v_entity_xiaofang' && userInfo.id_auth_role>1 && userInfo.id_entity) {
                  options[field] = getTreeOptions(data, userInfo.id_entity)
                } else {
                  options[field] = getTreeOptions(data, true)
                }
              } else if (column.form === 'selectTree' || column.form === 'selectTreeMultiple') {
                keyinfo[field] = getKeyinfo(data)
                const hasTreeData = data && data.length > 0 && data.some(o => o && o.children)
                options[field] = hasTreeData ? getTreeOptionsFromNested(data) : getTreeOptions(data, true)
              } else {
                keyinfo[field] = getKeyinfo(data)
                if(data && data.length>0){
                  options[field] = getOptions(data)
                }
                /* linkSelect: 额外缓存原始数据供第二级按需查找 */
                if (column.form === 'linkSelect') {
                  keyinfo['__raw_' + field] = data
                }
              }
            } catch (e) {
              // 关联表接口缺失/失败（如后端未建表）时降级，避免整页崩溃
              options[field] = []
              keyinfo[field] = {}
            }
          }
        } else if (extendOption) {
          try {
            let res = await Fan.api.get(`base_options?feature=${extendOption}`, {page: 1, limit: 99999})
            let list = (res && res.data) ? res.data : null
            // 兼容双层 {data:{data:[{options}]}} 和单层 [{options}]
            if (list && Array.isArray(list) && list.length > 0 && list[0].options) {
              // 单层格式
            } else if (list && list.data && Array.isArray(list.data) && list.data.length > 0 && list.data[0].options) {
              list = list.data
            } else {
              list = null
            }
            if (list) {
              const opts = list[0].options
              let extendOptions = {}
              const optsArr = []
              for (let k in opts) {
                const v = /^\d+$/.test(k) ? parseInt(k) : k
                extendOptions[v] = { name: opts[k] }
                optsArr.push({ label: opts[k], value: v })
              }
              keyinfo[field] = extendOptions
              options[field] = optsArr
            }
          } catch (e) {
            // 选项接口缺失/失败（如后端未配置该 feature）时降级，避免整页崩溃
            options[field] = []
            keyinfo[field] = {}
          }
        } else if (extendOption2) {
          try {
            let {data} = await Fan.api.get(`base_dictlist?feature=${extendOption2}`, {page: 1, limit: 99999,_reqorder:'order_num DESC,id ASC'})
            if (data && data.data) {
              data = data.data
              let extendOptions = {}
              const optsArr = []
              for (let k in data) {
                const row = data[k]
                // extendOption2（字典）的 value 就是字符串原值，与记录中存的值一致，不做类型转换。
                // 只修正：key 用 value（而非数组下标），避免字典记录顺序与 value 不对齐时列表/表单错位
                const v = row.value
                extendOptions[v] = { name: row.name, value: v }
                optsArr.push({ label: row.name, value: v })
              }
              keyinfo[field] = extendOptions
              options[field] = optsArr
            }
          } catch (e) {
            // 字典接口缺失/失败（如后端未配置该 feature）时降级，避免整页崩溃
            options[field] = []
            keyinfo[field] = {}
          }
        }
        /* numberWithUnit：加载配套字段的选项 */
        if (column.form === 'numberWithUnit') {
          const unitField = column.unitField || (field + '_unit')
          if (column.unitExtendTable) {
            try {
              const res = await Fan.api.get(column.unitExtendTable, { page: 1, limit: 99999 })
              let data = (res && res.data) ? res.data : (res || [])
              if (data && data.data && Array.isArray(data.data)) data = data.data
              if (data && data.length > 0) {
                const extOpts = {}
                const optsArr = []
                data.forEach(item => {
                  const id = item.id
                  const name = item.name || item.title || String(id)
                  extOpts[id] = { name }
                  optsArr.push({ label: name, value: id })
                })
                keyinfo[unitField] = extOpts
                options[unitField] = optsArr
              }
            } catch {}
          } else if (column.unitExtendOption) {
            try {
              let res = await Fan.api.get(`base_options?feature=${column.unitExtendOption}`, { page: 1, limit: 99999 })
              let list = (res && res.data) ? res.data : null
              if (list && list.data && Array.isArray(list.data) && list.data.length > 0 && list.data[0].options) list = list.data
              if (list && Array.isArray(list) && list.length > 0 && list[0].options) {
                const opts = list[0].options
                const extOpts = {}
                const optsArr = []
                for (let k in opts) {
                  const v = /^\d+$/.test(k) ? parseInt(k) : k
                  extOpts[v] = { name: opts[k] }
                  optsArr.push({ label: opts[k], value: v })
                }
                keyinfo[unitField] = extOpts
                options[unitField] = optsArr
              }
            } catch {}
          }
        }
      } else if (column.key && column.key==='action') {
        if (!column.width || (column.width && column.width===120)) {
          column.width=121
        }
        tableColumns[i] = column
        i++
      }
    }
    store.state.page = {
      columns: columns,
      keyinfo: keyinfo,
      options: options,
      tableColumns: tableColumns,
      data: payloadData
    }
    return payloadData
  }
  getOptionName(key, val, pix=' - ') {
    const options = store.state.page.keyinfo
    if (options && options[key] && options[key][val] && (typeof val==='number')) {
      const option = options[key][val]
      return option['name']
    } else if(options && options[key] && (typeof val==='string')) {
      const option = options[key]
      let optionnamek = ''
      for (let k in option) {
        if(option[k].value === val){
          optionnamek = option[k].name
        }
      }
      return optionnamek
    } else if (val===null || val===undefined) {
      return `暂无数据`
    } else {
      return `未知值：${val}`
    }
  }
  getOptionNamekk(key, val, pix=' - ') {
    const options = store.state.page.keyinfo
    if (options && options[key] && options[key][val]) {
      const option = options[key][val]
      return option['name']
    } else if (val===null || val===undefined) {
      return false
    } else {
      return `未知值：${val}`
    }
  }
  getOptionsz(payload) {
    let options = []
    if (payload[0].constructor==String) {
      for (let k in payload) {
        options.push({ value: parseInt(k), label: payload[k] })
      }
    } else {
      for (let k in payload) {
        options.push({ value: parseInt(payload[k].id), label: payload[k].name })
      }
    }
    return options
  }
}
function getOptions2(payload) {
  let options = []
  for (let k in payload) {
    options.push({ value: payload[k].value, label: payload[k].name })
  }
  return options
}
function getKeyinfo(payload, cascader=false) {
  let options = {}
  // 递归处理含 children 的树形数据
  const walk = (list) => {
    for (let k in list) {
      const option = list[k]
      if (!option || typeof option !== 'object') continue
      if (cascader) {
        if (option.id && option.name && option.pid_value && option.pid_name) {
          options[option.id] = {
            name: option.name,
            value: [...option.pid_value, `${option.id}`],
            pid_name: [...option.pid_name, `${option.name}`]
          }
        }
      } else {
        if (option.id) options[option.id] = { name: option.name }
      }
      if (option.children && option.children.length) walk(option.children)
    }
  }
  walk(payload)
  return options
}
function getOptionstr(payload) {
  let options = []
  for (let k in payload) {
      options.push({ value: payload[k].id, label: payload[k].name })
    }
  return options
}
function getOptions(payload) {
  let options = []
  if (payload[0].constructor==String) {
    for (let k in payload) {
      options.push({ value: parseInt(k), label: payload[k] })
    }
  } else {
    for (let k in payload) {
      options.push({ value: parseInt(payload[k].id), label: payload[k].name })
    }
  }
  return options
}
function getTreeOptions(payload, availableId=false) {
  let options = []
  let i = 0
  for (let k in payload) {
    const option = payload[k]
    if (!option.pid) {
      let children = {}
      if ((availableId&&availableId==option.id) || availableId===true) {
        options[i] = { label: option.name, value: `${option.id}` }
        delete payload[k]
        children = getTreeOptionsChild(payload, option.id, true)
      } else {
        options[i] = { label: option.name, value: `${option.id}`, disabled: true }
        delete payload[k]
        children = getTreeOptionsChild(payload, option.id, availableId)
      }
      if (Object.keys(children).length > 0) {
        options[i].children = children
      }
      i++
    }
  }
  return options
}
function getTreeOptionsChild(payload, pid, availableId) {
  let options = []
  let i = 0
  for (let k in payload) {
    const option = payload[k]
    if (option.pid && option.pid===pid) {
      let children = {}
      if ((availableId&&availableId==option.id) || availableId===true) {
        options[i] = { label: option.name, value: `${option.id}` }
        delete payload[k]
        children = getTreeOptionsChild(payload, option.id, true)
      } else {
        options[i] = { label: option.name, value: `${option.id}`, disabled: true }
        delete payload[k]
        children = getTreeOptionsChild(payload, option.id, availableId)
      }
      if (Object.keys(children).length > 0) {
        options[i].children = children
      }
      i++
    }
  }
  return options
}
/**
 * 将已嵌套的树形数据（API返回带children）转为cascader选项格式
 * 输入: [{id, name, pid, children:[{id,name,pid,children:[...]}]}]
 * 输出: [{label, value, children:[{label,value,children:[...]}]}]
 */
function getTreeOptionsFromNested(treeData) {
  if (!treeData || !treeData.length) return []
  const result = []
  for (let i = 0; i < treeData.length; i++) {
    const node = treeData[i]
    if (!node) continue
    const item = { label: node.name, value: `${node.id}`, ntype: node.ntype }
    if (node.children && node.children.length) {
      item.children = getTreeOptionsFromNested(node.children)
    }
    result.push(item)
  }
  return result
}

/**
 * 全局封装类
 */
class FanClass {
  constructor() {
    this.isDev = ISDEV
    this.message = message
    this.storage = new StorageClass()
    this.api = new ApiClass()
    this.utils = new UtilsClass()
    this.page = new PageClass()
    this.store = store
    /* Arco Design Vue 3: 用 Message.config 替代 Vue.prototype.$message.config */
    try { Message._config = Message._config || {}; } catch(e) {}
  }
  getToken() {
    return getToken()
  }
  async logout() {
    await this.api.delete('/login/1')
    message.info('正在跳转登录页面...', 1, () => {
      localStorage.removeItem('token')
      localStorage.removeItem('token-session')
      localStorage.removeItem('user-role')
      location.reload()
    })
  }
  errorHandler(error, vm) {
    ISDEV ? console.error(error) : console.warn('错误：', error.message)
    router.replace({ path: '/error/500' })
  }
  setPageParams(url, params, cover=false) {
    if (!cover) {
      const oldParams = this.getPageParams(url)
      params = Object.assign(oldParams, params)
    }
    sessionStorage.setItem(url, JSON.stringify(params))
    return params
  }
  getPageParams(url) {
    return JSON.parse(sessionStorage.getItem(url)) || {}
  }
  removePageParams(url, param=false) {
    let pageParams = this.getPageParams(url)
    sessionStorage.removeItem(url)
    if (!param) {
      delete pageParams[param]
      if (this.utils.notEmpty(pageParams)) {
        this.setPageParams(url, pageParams)
      }
    }
  }
}
function getToken() {
  const token = localStorage.getItem('token') || sessionStorage.getItem('token')
  return token || false
}

const Fan = new FanClass()

export {
  Fan
}